//====================================================
//  Function: Change Content INdex
//====================================================
function componentChangeContentIndex() {
  // Benefits
  if ($("#benefits").length) {
    var benefits = $("#benefits").clone();
    $("#content-wrapper").prepend($("#benefits"));

    $(".banners-row").after(benefits);
  }

  if ($(".otazka").length) {
    $(".sidebar").append($(".otazka").closest(".banner"));
  }
}
